module.exports = __webpack_public_path__ + "img/box04.067108c2.png";